<template>
  <table class="table b-table  table-hover table-bordered">
    <thead>
      <tr>
        <td>Situação comissão</td>
        <td>Consumidor</td>
        <td>Início</td>
        <td>Fim</td>
        <td>Número fatura</td>
        <td>Valor fatura</td>
        <td>Comissão</td>
        <td>Valor comissão</td>
      </tr>
    </thead>
    <tbody>
      <tr v-for="item in list" :key="item.id">
        <td>{{ item.hasComission ? 'OK' : 'Sem comissão no período' }}</td>
        <td>{{ item.name }}</td>
        <td>{{ item.start ? formatDate(item.start) : '' }}</td>
        <td>{{ item.end ? formatDate(item.end) : '' }}</td>
        <td>
          <a
            :href="
              `/#/user/${item.billing.userId}/installation/${item.billing.installationId}/billing/edit/${item.billing.billingId}/${item.billing.accountId}`
            "
            >Fatura {{ item.billing.billingId }}</a
          >
        </td>
        <td>{{ item.billing.value | currency }}</td>
        <td>{{ item.value ? item.value : 0 }} %</td>
        <td>{{ item.computedValue | currency }}</td>
      </tr>
      <tr>
        <td colspan="5"></td>
        <td>
          <strong>{{ getTotalValue() | currency }}</strong>
        </td>
        <td></td>
        <td>
          <strong>{{ getTotalComission() | currency }}</strong>
        </td>
      </tr>
    </tbody>
  </table>
</template>
<script>
import { Api } from '../../vue/api';
import moment from 'moment-timezone';

const API = new Api();

export default {
  name: 'sales-comissions-index-report-table',
  data: function() {
    return {};
  },
  computed: {},

  methods: {
    getTotalValue() {
      return _.sumBy(this.list, b => parseFloat(b.billing.value));
    },

    getTotalComission() {
      return _.sumBy(this.list, b => b.computedValue);
    },
    formatDate(date) {
      return moment(date).format('L');
    },
  },
  components: {},
  props: ['list'],
};
</script>
